import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
} from '@angular/core';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { FontColor, TextSize } from '@freelancer/ui/text';
import { IconColor } from '../icon';
import {
  LinkColor,
  LinkHoverColor,
  LinkIconPosition,
  LinkWeight,
} from '../link';

@Component({
  selector: 'fl-section-homepage-entry-heading',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHomepageEntryHeadingComponent {}

@Component({
  selector: 'fl-section-homepage-entry-description',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHomepageEntryDescriptionComponent {}

@Component({
  selector: 'fl-section-homepage-entry-link',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHomepageEntryLinkComponent {}

@Component({
  selector: 'fl-section-homepage-entry',
  template: `
    <div
      [flMarginBottom]="'mid'"
      [flMarginBottomTablet]="'large'"
      [flMarginBottomDesktopLarge]="'xlarge'"
    >
      <fl-heading
        [color]="HeadingColor.LIGHT"
        [headingType]="HeadingType.H3"
        [size]="TextSize.MID"
        [sizeDesktop]="TextSize.XLARGE"
        [flMarginBottom]="'xxxsmall'"
        [flMarginBottomTablet]="'xxsmall'"
        [flMarginBottomDesktop]="'xsmall'"
      >
        <ng-content select="fl-section-homepage-entry-heading"></ng-content>
      </fl-heading>
      <fl-text
        [color]="FontColor.LIGHT"
        [size]="TextSize.XSMALL"
        [sizeDesktop]="TextSize.MID"
        [flMarginBottom]="sectionHomepageEntryLinkComponent ? 'xsmall' : 'none'"
        [flMarginBottomTablet]="
          sectionHomepageEntryLinkComponent ? 'small' : 'none'
        "
      >
        <ng-content select="fl-section-homepage-entry-description"></ng-content>
      </fl-text>
      <fl-link
        *ngIf="sectionHomepageEntryLinkComponent"
        flTrackingLabel="flTrackingLabel"
        [color]="LinkColor.PRIMARY"
        [iconColor]="IconColor.PRIMARY"
        [iconName]="'ui-arrow-right'"
        [iconPosition]="LinkIconPosition.RIGHT"
        [hoverColor]="LinkHoverColor.PRIMARY"
        [link]="link"
        [size]="TextSize.MARKETING_SMALL"
        [weight]="LinkWeight.BOLD"
      >
        <ng-content select="fl-section-homepage-entry-link"></ng-content>
      </fl-link>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHomepageEntryComponent {
  FontColor = FontColor;
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  IconColor = IconColor;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkHoverColor = LinkHoverColor;
  LinkWeight = LinkWeight;
  TextSize = TextSize;

  @Input() flTrackingLabel: string;
  @Input() link: string;

  @ContentChild(SectionHomepageEntryLinkComponent)
  sectionHomepageEntryLinkComponent: SectionHomepageEntryLinkComponent;
}
